import { render, staticRenderFns } from "./MdSolveShow.vue?vue&type=template&id=10ec4b97&scoped=true&"
import script from "./MdSolveShow.vue?vue&type=script&lang=js&"
export * from "./MdSolveShow.vue?vue&type=script&lang=js&"
import style0 from "./MdSolveShow.vue?vue&type=style&index=0&id=10ec4b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec4b97",
  null
  
)

export default component.exports